(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-variant-picker-detail"] && !Shopify.designMode) return;
  try {
    const normalizeMm = (value) =>
    value ? value.toString().replace('mm', '').replace(',', '.').replace(/\s+/g, '') : null;

  const applyThumbnailFromTemplate = (thumbnailEl, templateEl) => {
    if (!thumbnailEl || !templateEl) return;

    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = templateEl.innerHTML;
    const templateImg = tempContainer.querySelector('img');
    const src = templateImg?.getAttribute('src');

    if (!src) {
      thumbnailEl.classList.add('hidden');
      thumbnailEl.innerHTML = '';
      return;
    }

    const probe = new Image();
    probe.onload = () => {
      thumbnailEl.classList.remove('hidden');
      thumbnailEl.innerHTML = templateEl.innerHTML;
    };
    probe.onerror = () => {
      thumbnailEl.classList.add('hidden');
      thumbnailEl.innerHTML = '';
    };
    probe.src = src;
  };

  const addThumbnails = () => {
    const thumbnailTemplates = document.querySelectorAll('[data-cc-select-thumbnail-data]');
    thumbnailTemplates.forEach((template) => {
      const optionToTarget = template.dataset.optionToTarget;
      const valueToTarget = template.dataset.valueToTarget?.split(' ').join('');
      const target = document.querySelector(`[data-option-label="${optionToTarget}"] + .cc-select`);
      if (!target) return;
      const thumbnailElement = target.querySelector(`[data-cc-select-thumbnail="${valueToTarget}"]`);
      applyThumbnailFromTemplate(thumbnailElement, template);
    });
  };

  const appendExtensions = () => {
    const ccSelectExtensions = document.querySelectorAll('[data-cc-select-extension]');
    ccSelectExtensions.forEach((extension) => {
      const optionToTarget = extension.dataset.optionToTarget;
      const target = document.querySelector(`[data-option-label="${optionToTarget}"] + .cc-select`);
      if (!target) return;
      const extendedContent = target.querySelector('[data-cc-select-extension-target]');
      if (!extendedContent) return;
      extendedContent.classList.remove('hidden');
      extendedContent.innerHTML = extension.innerHTML;
    });
  };

  const appendInfoModals = () => {
    const infoModals = document.querySelectorAll('[data-cc-select-info-modal]');
    infoModals.forEach((template) => {
      const optionToTarget = template.dataset.optionToTarget;
      const target = document.querySelector(`[data-option-label="${optionToTarget}"]`);
      if (!target) return;
      const existingModalContent = target.querySelector('.modal-container');
      if (existingModalContent) existingModalContent.remove();
      target.insertAdjacentHTML('beforeend', template.innerHTML);

      $(document).trigger('cc:component:load', ['modal', target]);
    });
  };

  const getSelectedOptionValue = (variant, option) => {
    const productData = JSON.parse(document.getElementById(`ProductJson-${variant.product_id}`).innerHTML);

    let optionKey = null;

    for (let i = productData.options.length - 1; i >= 0; i--) {
      if (productData.options[i].toLowerCase() === option.toLowerCase()) {
        const optionIndex = i;
        optionKey = `option${optionIndex + 1}`;
        break;
      }
    }
    if (!optionKey) return null;
    const selectedOptionValue = variant[optionKey];
    return selectedOptionValue
  };

  const addThicknessThumbnails = (variant) => {
    const templates = document.querySelectorAll('[data-cc-select-thickness-thumbnail-data]');
    const variantData = JSON.parse(document.getElementById(`VariantJson-${variant.id}`).innerHTML);

    templates.forEach((template) => {
      const { optionToTarget, thicknessValue, widthOptionName, widthValue } = template.dataset;
      const selectedWidth = getSelectedOptionValue(variant, widthOptionName) ?? variantData.product_group_label // Fix for variants that do not have a width applied
      if (!selectedWidth) return;

      const thicknessKey = normalizeMm(thicknessValue);
      const widthKey = normalizeMm(selectedWidth);
      const templateWidthKey = normalizeMm(widthValue);
      if (!thicknessKey || !widthKey || widthKey !== templateWidthKey) return;

      const target = document.querySelector(`[data-option-label="${optionToTarget}"] + .cc-select`);
      if (!target) return;

      const thumbnailElement = target.querySelector(`[data-cc-select-thumbnail="${thicknessKey}mm"]`);
      if (!thumbnailElement) return;

      const img = new Image();
      img.width = 40;
      img.height = 40;
      img.alt = thicknessValue;

      img.onload = () => {
        thumbnailElement.classList.remove('hidden');
        thumbnailElement.innerHTML = '';
        thumbnailElement.appendChild(img);
      };

      img.onerror = () => {
        thumbnailElement.classList.add('hidden');
        thumbnailElement.innerHTML = '';
      };

      img.src = template.dataset.assetUrl;
    });
  };

  const injectProductGroupSelectors = () => {
    document.querySelectorAll('[data-product-group-data]').forEach((scriptEl) => {
      const inputRow = scriptEl.closest('.input-row');
      if (!inputRow) return;

      const optionSelectors = inputRow.querySelector('.option-selectors');
      if (!optionSelectors) return;

      let data;
      try { data = JSON.parse(scriptEl.textContent); } catch(e) { return; }

      // Detect style from existing variant option selectors
      const existingSelector = optionSelectors.querySelector('.option-selector:not([data-product-group])');
      const style = existingSelector?.dataset.selectorType || 'listed';

      // Find the original option selector BEFORE we modify the DOM
      const originalSelector = Array.from(
        optionSelectors.querySelectorAll('.option-selector')
      ).find((sel) =>
        sel.querySelector(`[data-option-label="${data.label}"]`) ||
        Array.from(sel.querySelectorAll('legend')).some((l) => l.textContent.trim() === data.label)
      );

      // Remove previously injected selector
      optionSelectors.querySelector('[data-product-group]')?.remove();

      const selectorId = scriptEl.dataset.selectorId;
      const selectorEl = document.createElement('div');
      selectorEl.className = 'option-selector order-1';
      selectorEl.dataset.selectorType = style;
      selectorEl.setAttribute('data-product-group', '');

      if (style === 'dropdown') {
        const currentProduct = data.products.find(p => p.isCurrent);
        const currentIndex = data.products.indexOf(currentProduct);

        const labelEl = document.createElement('label');
        labelEl.setAttribute('data-option-label', data.label);
        labelEl.id = selectorId + '-label';
        labelEl.className = 'label no-js-hidden';
        labelEl.textContent = data.label;

        const btn = document.createElement('button');
        btn.className = 'cc-select__btn';
        btn.type = 'button';
        btn.setAttribute('aria-haspopup', 'listbox');
        btn.setAttribute('aria-labelledby', selectorId + '-label');
        btn.textContent = currentProduct?.label || data.products[0]?.label || '';
        btn.insertAdjacentHTML('beforeend', '<svg class="cc-select__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>');

        const ul = document.createElement('ul');
        ul.className = 'cc-select__listbox';
        ul.setAttribute('role', 'listbox');
        ul.setAttribute('tabindex', '-1');
        ul.setAttribute('aria-hidden', 'true');
        if (currentProduct) ul.setAttribute('aria-activedescendant', `${selectorId}-opt-${currentIndex}`);

        data.products.forEach((product, i) => {
          const li = document.createElement('li');
          li.className = 'cc-select__option js-option';
          li.id = `${selectorId}-opt-${i}`;
          li.setAttribute('role', 'option');
          li.dataset.productUrl = product.url;
          li.dataset.value = product.label;
          li.dataset.optionName = data.label;
          if (product.isCurrent) li.setAttribute('aria-selected', 'true');

          const thumbnailSpan = document.createElement('span');
          thumbnailSpan.className = 'cc-select__option-thumbnail';
          thumbnailSpan.setAttribute('data-cc-select-thumbnail', product.label.split(' ').join(''));
          li.appendChild(thumbnailSpan);

          const span = document.createElement('span');
          span.textContent = product.label;
          li.appendChild(span);
          ul.appendChild(li);
        });

        // Required extension target slot
        const extLi = document.createElement('li');
        extLi.className = 'hidden cc-select-extended-content rte';
        extLi.setAttribute('data-cc-select-extension-target', '');
        ul.appendChild(extLi);

        const selectEl = document.createElement('div');
        selectEl.className = 'cc-select no-js-hidden';
        selectEl.id = selectorId;
        selectEl.appendChild(btn);
        selectEl.appendChild(ul);

        selectorEl.appendChild(labelEl);
        selectorEl.appendChild(selectEl);
        optionSelectors.prepend(selectorEl);

        // Apply thumbnails from any [data-cc-select-thumbnail-data] templates, matching by value
        document.querySelectorAll('[data-cc-select-thumbnail-data]').forEach((tmpl) => {
          const valueToTarget = tmpl.dataset.valueToTarget?.split(' ').join('');
          if (!valueToTarget) return;
          const thumbnailEl = selectEl.querySelector(`[data-cc-select-thumbnail="${valueToTarget}"]`);
          applyThumbnailFromTemplate(thumbnailEl, tmpl);
        });

        // Initialise the cc-select component on the injected element
        $(document).trigger('cc:component:load', ['custom-select', selectorEl]);

      }

      // Hide the original option selector that this product group replaces
      if (originalSelector) originalSelector.style.display = 'none';
    });
  };

  const addVariantPickerEnhancements = () => {
    addThumbnails();
    injectProductGroupSelectors();
    appendInfoModals();
    appendExtensions();
  };

  document.addEventListener('DOMContentLoaded', addVariantPickerEnhancements);
  document.addEventListener('product:swapped', addVariantPickerEnhancements);

  const handleVariantUpdated = (_event, payload) => {
    const { variant = null } = payload || {};
    if (!variant) return;

    addThicknessThumbnails(variant);
  };

  // prevent duplicate listeners when scripts are re-injected after product swaps
  if (window.jQuery) {
    window
      .jQuery(window)
      .off('cc-variant-updated.variantPickerDetail')
      .on('cc-variant-updated.variantPickerDetail', handleVariantUpdated);
  }
  } catch(e) { console.error(e); }
})();

})();
